export const GetAreaName = (area) => {
  let name: string = ""
  switch (area) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      name = "Area " + area
      break
    case 0:
      name = "Core"
      break
    case 7:
      name = "Sci/Math"
      break
    case 8:
      name = "Other"
      break
  }
  return name
}

export const GetAreaFullName = (area) => {
  let name: string[] = [""]
  switch (area) {
    case 1:
      name = ["Photonics & ", "Semiconductor Phys."]
      break
    case 2:
      name = ["Energy Systems & ", "Electromagnetics"]
      break
    case 3:
      name = ["Analog &", "Digital Electronics"]
      break
    case 4:
      name = ["Control, Comms. &", "Digital Signal Proc."]
      break
    case 5:
      name = ["Computer Hardware & ", "Computer Networks"]
      break
    case 6:
      name = ["", "Software"]
      break
    case 0:
      name = ["Core", "Y1/Y2 Courses"]
      break
    case 7:
      name = ["Sci/Math ","Electives"]
      break
    case 8:
      name = ["Required","Upper Year Courses"]
      break
  }
  return name
}